import { useBrand } from 'modules/shared/brand/hooks/useBrand';

const useBrandFavicon = () => {
  const { brand } = useBrand();

  return `/${brand.toLowerCase()}/favicon.ico`;
};

export default useBrandFavicon;
